export const odontologo = {
  nome: 'Odontólogo(a)',
  id_perfil: 8,
  dashboard: [
    {
      link: '/vinculo-acompanhamento',
      titulo: 'Vínculo e Acompanhamento',
      icone: false,
      imagem: '',
      svg: 'GestaoCadastros',
      key: 'vinculo_acompanhamento',
      featured: true,
    },
    {
      link: '/indicadores-aps',
      titulo: 'Indicadores APS',
      icone: false,
      imagem: '',
      svg: 'IndicadoresAps',
      key: 'indicadores_aps',
      featured: true,
    },
    {
      link: '/gestao-cadastros',
      titulo: 'Gestão cadastros',
      icone: false,
      imagem: '',
      svg: 'GestaoCadastros',
      key: 'gestao_cadastros',
    },
    {
      link: '/atendimentos-no-mes',
      titulo: 'Relatório atendimentos',
      icone: 'icofont-list',
      key: 'atendimentos_no_mes',
    },
    {
      link: '/tria/profissional',
      titulo: 'TRIA',
      icone: 'icofont-culinary',
      key: 'tria',
    },
    {
      link: '/ceo',
      titulo: 'CEO',
      icone: 'icofont-tooth',
      key: 'ceo',
    },
    // {
    //   link: '/indicadores-esb',
    //   titulo: 'Indicadores eSB',
    //   icone: false,
    //   imagem: '',
    //   svg: 'IndicadoresEsb',
    //   key: 'indicadores_esb',
    // },
  ],
  administracao: [],
  gestao_cadastros: [
    {
      link: '/acs-por-cidadao',
      titulo: 'Cidadão',
      icone: 'icofont-users-alt-4',
      key: 'cidadao',
    },
    {
      link: '/cidadaos-desvinculados',
      titulo: 'Cidadãos sem equipe',
      icone: 'icofont-people',
      key: 'cidadaos_sem_equipe',
    },
    {
      link: '/cidadaos-duplicados/equipe',
      titulo: 'Cidadãos duplicados',
      icone: 'icofont-copy-invert',
      key: 'cidadaos_duplicados',
    },
    {
      link: '/cidadaos-sem-acs',
      titulo: 'Cidadãos sem ACS',
      icone: 'icofont-users-alt-4',
      key: 'cidadaos_sem_acs',
    },
    {
      link: '/cadastros-sem-cpf/equipe',
      titulo: 'Cadastros sem CPF',
      icone: 'icofont-copy-invert',
      key: 'cadastros_sem_cpf',
    },
    {
      link: '/calculadora-de-pessoas/equipe',
      titulo: 'Calculadora de pessoas',
      icone: 'icofont-ui-calculator',
      key: 'calculadora_de_pessoas',
    },
    {
      link: '/obitos/profissional',
      titulo: 'Óbitos',
      icone: 'icofont-list',
      key: 'obitos',
    },
    {
      link: '/mudanca_territorio/profissional',
      titulo: 'Mudança de Território',
      icone: 'icofont-list',
      key: 'mudanca_territorio',
    },
  ],
  visitas_domiciliares: [],
  imunizacao: [],
  vacina_idade_certa: [],
  divergencia_vacinas: [],
  indicadores_aps: [
    {
      link: '/pre-natal',
      titulo: 'Gestantes e Puérperas',
      icone: false,
      imagem: require('@/assets/images/pregnant.png'),
      key: 'pre_natal',
      ribbon: {
        enabled: true,
        text: 'ESF',
      },
    },
    {
      link: '/saude-da-mulher',
      titulo: 'Saúde da mulher',
      icone: 'icofont-female',
      key: 'saude_da_mulher',
      ribbon: {
        enabled: true,
        text: 'ESF',
      },
    },
    {
      link: '/pessoa-idosa',
      titulo: 'Pessoa idosa',
      icone: 'icofont-drug',
      key: 'pessoa_idosa',
      ribbon: {
        enabled: true,
        text: 'ESF',
      },
    },
    {
      link: '/primeira-consulta-programada',
      titulo: '1ª Consulta programada',
      icone: false,
      imagem: '',
      svg: 'PrimeiraConsultaProgramada',
      key: 'primeira_consulta_programada',
      ribbon: {
        enabled: true,
        text: 'eSB',
      },
    },
    {
      link: '/tratamentos-concluidos',
      titulo: 'Tratamentos concluídos',
      icone: false,
      imagem: '',
      svg: 'TratamentosConcluidos',
      key: 'tratamentos_concluidos',
      ribbon: {
        enabled: true,
        text: 'eSB',
      },
    },
    {
      link: '/exodontias',
      titulo: 'Exodontias',
      icone: false,
      imagem: '',
      svg: 'Exodontias',
      key: 'exodontias',
      ribbon: {
        enabled: true,
        text: 'eSB',
      },
    },
    {
      link: '/escovacao-supervisionada',
      titulo: 'Escovação supervisionada',
      icone: false,
      imagem: '',
      svg: 'EscovacaoSupervisionada',
      key: 'escovacao_supervisionada',
      ribbon: {
        enabled: true,
        text: 'eSB',
      },
    },
    {
      link: '/proporcao-procedimentos-preventivos',
      titulo: 'Procedimentos preventivos',
      icone: false,
      imagem: '',
      svg: 'Prevencao',
      key: 'proporcao_procedimentos_preventivos',
      ribbon: {
        enabled: true,
        text: 'eSB',
      },
    },
    {
      link: '/tratamentos-restauradores-art',
      titulo: 'Tratamento restaurador',
      icone: false,
      imagem: '',
      svg: 'TratamentosRestauradoresArt',
      key: 'tratamentos_restauradores_art',
      ribbon: {
        enabled: true,
        text: 'eSB',
      },
    },
    {
      link: '/cuidado-compartilhado',
      titulo: 'Cuidado compartilhado',
      icone: 'icofont-duotone icofont-field-group',
      key: 'cuidado_compartilhado',
      ribbon: {
        enabled: true,
        text: 'eMulti',
      },
    },
    {
      link: '/acoes-interprofissionais',
      titulo: 'Ações interprofissionais',
      icone: 'icofont-duotone icofont-field-group',
      key: 'acoes_interprofissionais',
      ribbon: {
        enabled: true,
        text: 'eMulti',
      },
    },
    {
      link: '/comunicacao-emulti-e-equipes',
      titulo: 'Comunicação',
      icone: 'icofont-ui-chat',
      key: 'comunicacao_emulti_equipes',
      ribbon: {
        enabled: true,
        text: 'eMulti',
      },
    },
    {
      link: '/resolutividade-cuidado-emulti',
      titulo: 'Resolutividade',
      icone: 'icofont-duotone icofont-field-group',
      key: 'resolutividade_cuidado_emulti',
      ribbon: {
        enabled: true,
        text: 'eMulti',
      },
    },
    {
      link: '/resultado-isf-acs',
      titulo: 'Resultado ISF',
      icone: false,
      imagem: '',
      svg: 'ResultadoIsf',
      key: 'resultado_isf',
    },
    {
      link: '/desempenho-por-equipe',
      titulo: 'Desempenho por Equipe',
      icone: false,
      imagem: '',
      svg: 'DesempenhoPorEquipe',
      key: 'desempenho_por_equipe',
    },
  ],
  pre_natal: [
    {
      link: '/consultas-odontologicas/profissional',
      titulo: 'Consultas odontológicas',
      icone: false,
      imagem: '',
      svg: 'ConsultasOdontologicas',
      key: 'consultas_odontologicas',
    },
  ],
  doencas_cronicas: [
    {
      link: '/hemoglobina-glicada/profissional',
      titulo: 'Atendimento diabetes',
      icone: false,
      imagem: '',
      svg: 'AtendimentosDiabetes',
      key: 'atendimento_diabetes',
    },
    {
      link: '/atendimento-hipertensao/profissional',
      titulo: 'Atendimento Hipertensão',
      icone: false,
      imagem: '',
      svg: 'AtendimentoHipertensao',
      key: 'atendimento_hipertensao',
    },
    {
      link: '/hiper-dia/profissional',
      titulo: 'Atendimento HiperDia',
      icone: false,
      imagem: '',
      svg: 'HiperDia',
      key: 'atendimento_hiper_dia',
    },
  ],
  desempenho_por_equipe: [
    {
      link: '/desempenho-por-equipe/indicador',
      titulo: 'Desempenho por Indicador',
      icone: 'icofont-brand-designbump',
      key: 'desempenho_por_indicador',
    },
    {
      link: '/desempenho-por-equipe/geral',
      titulo: 'Desempenho Geral',
      icone: 'icofont-brand-designbump',
      key: 'desempenho_geral',
    },
  ],
  saude_crianca: [],
  indicadores_esb: [
    {
      link: '/indicadores-esb/estrategicos',
      titulo: 'Estratégicos',
      icone: false,
      imagem: '',
      svg: 'Estrategicos',
      key: 'indicadores_esb_estrategicos',
    },
    {
      link: '/indicadores-esb/ampliados',
      titulo: 'Ampliados',
      icone: false,
      imagem: '',
      svg: 'Ampliados',
      key: 'indicadores_esb_ampliados',
    },
  ],
  indicadores_esb_estrategicos: [
    {
      link: '/indicadores-esb/estrategicos/gestantes',
      titulo: 'Gestantes',
      icone: false,
      imagem: '',
      svg: 'Gestantes',
      key: 'estrategicos_gestantes',
    },
    {
      link: '/indicadores-esb/estrategicos/criancas',
      titulo: 'Crianças',
      icone: false,
      imagem: '',
      svg: 'Criancas',
      key: 'estrategicos_criancas',
    },
    {
      link: '/indicadores-esb/estrategicos/atendimentos-na-esb',
      titulo: 'Atendimentos na eSB',
      icone: false,
      imagem: '',
      svg: 'AtendimentosNaEsb',
      key: 'atendimentos_na_esb',
    },
  ],
  indicadores_esb_ampliados: [
    {
      link: '/indicadores-esb/ampliados/prevencao',
      titulo: 'Prevenção',
      icone: false,
      imagem: '',
      svg: 'Prevencao',
      key: 'prevencao',
    },
    {
      link: '/indicadores-esb/ampliados/atendimentos-domiciliares',
      titulo: 'Atendimentos domiciliares',
      icone: false,
      imagem: '',
      svg: 'AtendimentosDomiciliares',
      key: 'ampliados_atendimentos_domiciliares',
    },
    {
      link: '/indicadores-esb/ampliados/agendamentos-72h',
      titulo: 'Agendamentos 72h',
      icone: false,
      imagem: '',
      svg: 'Agendamentos72h',
      key: 'agendamentos_72h',
    },
    {
      link: '/indicadores-esb/ampliados/satisfacao-do-cidadao',
      titulo: 'Satisfação do cidadão',
      icone: false,
      imagem: '',
      svg: 'SatisfacaoDoCidadao',
      key: 'satisfacao_do_cidadao',
    },
  ],
  producao: [],
  vinculo_acompanhamento: [
    {
      link: '/diagnostico-situacional',
      titulo: 'Desempenho por Equipe',
      icone: false,
      imagem: '',
      svg: 'DesempenhoPorEquipe',
      key: 'diagnostico_situacional',
    },
    {
      link: '/cadastros-individuais/profissional',
      titulo: 'Cadastros cidadãos',
      icone: false,
      imagem: '',
      svg: 'CadastrosCidadaos',
      key: 'cadastros_cidadaos',
    },
    {
      link: '/acompanhamento/profissional',
      titulo: 'Acompanhamento',
      icone: false,
      imagem: '',
      svg: 'Acompanhamento',
      key: 'acompanhamento',
    },
    {
      link: '/avaliacao-atendimentos',
      titulo: 'Avaliação do atendimento',
      icone: 'icofont-heart-eyes',
      key: 'avaliacao_atendimentos',
    },
    {
      link: '/agenda-por-profissional/profissional',
      titulo: 'Agendamentos',
      icone: 'icofont-ui-calendar',
      key: 'agenda_por_profissional',
    },
  ],
  bpa_e_ras: [],
}
